import { Response } from 'app/api/Response';
import UserApi from 'app/api/UserApi';
import { useFormik } from 'formik';
import { Box, Button, FormGroup, Input, VGrid, useToasts } from 'tombac';
import { object, ref, string } from 'yup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const validationSchema = object({
  repeat: string().required('Password confirmation is required').oneOf([ref('new')], 'Passwords do not match'),
  new: string().required('New password is required').min(6, 'Password must have at least ${min} characters')
});
const ChangePasswordForm = layoutProps => {
  const {
    addToast
  } = useToasts();
  const formik = useFormik({
    initialValues: {
      old: '',
      new: '',
      repeat: ''
    },
    onSubmit: async ({
      old,
      new: newPass,
      repeat
    }) => {
      const response = await UserApi.setPassword(old, newPass, repeat);
      return Response.match(response, () => {
        addToast('Your password has been successfully changed', 'success');
        formik.resetForm();
      }, error => {
        console.error(error);
        addToast(error?.message ?? (typeof error === 'string' ? error : 'Error while changing password. Please try again.'), 'danger');
      });
    },
    validationSchema
  });
  const getFormGroupProps = name => ({
    caption: formik.touched[name] && formik.errors[name],
    danger: Boolean(formik.touched[name] && formik.errors[name])
  });
  const getInputProps = name => ({
    ...formik.getFieldProps(name),
    $width: '100%',
    invalid: Boolean(formik.touched[name] && formik.errors[name])
  });
  return /*#__PURE__*/_jsxs(Box, {
    as: "form",
    onSubmit: formik.handleSubmit,
    ...layoutProps,
    "data-sentry-element": "Box",
    "data-sentry-component": "ChangePasswordForm",
    "data-sentry-source-file": "ChangePasswordForm.tsx",
    children: [/*#__PURE__*/_jsxs(VGrid, {
      justifyContent: "stretch",
      "data-sentry-element": "VGrid",
      "data-sentry-source-file": "ChangePasswordForm.tsx",
      "data-sentry-element": "VGrid",
      children: [/*#__PURE__*/_jsx(FormGroup, {
        label: "Old password",
        ...getFormGroupProps('old'),
        "data-sentry-element": "FormGroup",
        "data-sentry-source-file": "ChangePasswordForm.tsx",
        "data-sentry-element": "FormGroup",
        children: /*#__PURE__*/_jsx(Input, {
          type: "password",
          ...getInputProps('old'),
          "data-sentry-element": "Input",
          "data-sentry-source-file": "ChangePasswordForm.tsx",
          "data-sentry-element": "Input"
        })
      }), /*#__PURE__*/_jsx(FormGroup, {
        label: "New password",
        ...getFormGroupProps('new'),
        "data-sentry-element": "FormGroup",
        "data-sentry-source-file": "ChangePasswordForm.tsx",
        "data-sentry-element": "FormGroup",
        children: /*#__PURE__*/_jsx(Input, {
          type: "password",
          ...getInputProps('new'),
          "data-sentry-element": "Input",
          "data-sentry-source-file": "ChangePasswordForm.tsx",
          "data-sentry-element": "Input"
        })
      }), /*#__PURE__*/_jsx(FormGroup, {
        label: "Confirm password",
        ...getFormGroupProps('repeat'),
        "data-sentry-element": "FormGroup",
        "data-sentry-source-file": "ChangePasswordForm.tsx",
        "data-sentry-element": "FormGroup",
        children: /*#__PURE__*/_jsx(Input, {
          type: "password",
          ...getInputProps('repeat'),
          "data-sentry-element": "Input",
          "data-sentry-source-file": "ChangePasswordForm.tsx",
          "data-sentry-element": "Input"
        })
      })]
    }), /*#__PURE__*/_jsx(Button, {
      busy: formik.isSubmitting,
      disabled: !formik.dirty,
      $ml: "auto",
      $mt: "3sp",
      type: "submit",
      variant: "primary",
      "data-sentry-element": "Button",
      "data-sentry-source-file": "ChangePasswordForm.tsx",
      "data-sentry-element": "Button",
      children: "Change password"
    })]
  });
};
export default ChangePasswordForm;